import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
// hooks
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  // Hooks
  const router = useRouter();
  // Context
  const { authenticated, loading } = useAuthContext();
  // States
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if(!loading) {
      if(authenticated) {
        setChecked(true);
      } else {
        router.replace(paths.auth.login);
      }
    }
  }, [authenticated, loading]);

  if (!checked) return null;

  return <>{children}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};
